import { FunctionComponent } from 'react'
import { Question } from 'Frontend/scripts/models/foodHabits.model'

type Props = {
  question: Question
  answers: { [key: string]: number | number[] }
  handleAnswer: (questionId: string, value: number) => void
}

const WeekCheckBoxes: FunctionComponent<Props> = ({ question, answers, handleAnswer }) => {
  const scorePerDay = question.scorePerDay || 1
  const days = Array.from({ length: 8 }, (_, i) => i)

  const handleChange = (value: number) => {
    // Sätt det nya valet och avmarkera andra
    handleAnswer(question.id, value)
  }

  return (
    <div className="week-days d-flex justify-content-center flex-wrap">
      {days.map((day) => {
        const value = scorePerDay * day
        return (
          <label key={day} className="week-days__option m-2 d-flex flex-column align-items-center">
            <span className="week-days__radio-wrapper">
              <input
                type="checkbox"
                value={value}
                checked={answers[question.id] === value}
                onChange={() => handleChange(value)}
                className="week-days__input"
                aria-label={`${day} ${day === 1 ? 'dag' : 'dagar'}`}
                role="radio" // Efterliknar radio-knapp för skärmläsare
                aria-checked={answers[question.id] === value}
                tabIndex={0} // Säkerställer tab-navigering
              />
              <span className="week-days__indicator"></span>
            </span>
            <span className="week-days__text ms-2 fw-light">{`${day} ${day === 1 ? 'dag' : 'dagar'}`}</span>
          </label>
        )
      })}
    </div>
  )
}

export default WeekCheckBoxes
